module.exports = __webpack_public_path__ + "img/zxcx.8ca99e89.jpg";